/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CSSTransition } from 'react-transition-group';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuestionCircle,
  faExternalLinkSquareAlt,
} from '@fortawesome/pro-solid-svg-icons';
import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { UserAvatar } from 'components';
import { withApi } from 'infrastructure/api';
import { withCurrentUser } from 'infrastructure/currentUser';
import { deleteCookie } from 'infrastructure/security/cookies';

const enhance = compose(
  withApi,
  withCurrentUser,
  connect(null, (dispatch, props) => ({
    api: {
      auth: bindActionCreators(props.api.auth.auth, dispatch),
    },
  }))
);

const TopRightNav = props => {
  const { currentUser, api } = props;

  const [helpMenuOpen, setHelpMenuOpen] = useState(false);
  const toggleHelpMenu = () => {
    setHelpMenuOpen(prevState => !prevState);
    document.activeElement.blur();
  };

  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const toggleProfileMenu = () => {
    setProfileMenuOpen(prevState => !prevState);
    document.activeElement.blur();
  };

  const logout = () => {
    deleteCookie('app');
    localStorage.clear();
    // eslint-disable-next-line react/destructuring-assignment
    api.auth.logout();
  };

  // eslint-disable-next-line max-len
  const mailtoLink = `mailto:support@usechimney.com?subject=Chimney%20CMS%20Support&body=Hi%20Chimney%20Support%2C%0D%0A%0D%0A--%3E%20Replace%20this%20line%20with%20a%20description%20of%20the%20issue.%0D%0A%0D%0A%0D%0A---%0D%0A%0D%0APlease%20don't%20delete%20anything%20below%20this%20line%2C%20it%20will%20help%20us%20debug%20the%20issue.%0D%0A%0D%0A${document.title}%20%7C%20${window.location}%20%7C%20${navigator.userAgent}`;

  return (
    <>
      {/* <Dropdown
        isOpen={helpMenuOpen}
        toggle={toggleHelpMenu}
        className="topbar-dropdown-nav"
      >
        <DropdownToggle className="topbar-dropdown-trigger">
          <FontAwesomeIcon aria-label="Help Menu" icon={faQuestionCircle} />
        </DropdownToggle>
        <CSSTransition in={helpMenuOpen} classNames="dropdown" timeout={200}>
          <DropdownMenu right>
            <DropdownItem header>Support</DropdownItem>
            <DropdownItem href="https://docs.usechimney.com" target="_blank">
              User Guide{' '}
              <FontAwesomeIcon
                icon={faExternalLinkSquareAlt}
                className="text-muted"
              />
            </DropdownItem>
            <DropdownItem href={mailtoLink} target="_blank">
              Report an issue
            </DropdownItem>
          </DropdownMenu>
        </CSSTransition>
      </Dropdown> */}
      <Dropdown
        isOpen={profileMenuOpen}
        toggle={toggleProfileMenu}
        className="topbar-dropdown-nav"
      >
        <DropdownToggle className="topbar-dropdown-trigger">
          <UserAvatar userName={currentUser && currentUser.name} />
        </DropdownToggle>
        <CSSTransition in={profileMenuOpen} classNames="dropdown" timeout={200}>
          <DropdownMenu right>
            <DropdownItem onClick={() => logout()}>
              <FontAwesomeIcon icon={faSignOut} className="highlight-icon" />{' '}
              Log Out
            </DropdownItem>
          </DropdownMenu>
        </CSSTransition>
      </Dropdown>
    </>
  );
};

TopRightNav.propTypes = {
  api: PropTypes.shape().isRequired,
  currentUser: PropTypes.shape().isRequired,
};

export default enhance(TopRightNav);
/* eslint-enable no-unused-vars */
